import { patchSingle } from '@/helper/apicalls';

import { baseURL } from './const';

export async function contactAction({ request, params }: any) {
  const body = Object.fromEntries(await request.formData());

  if (body?.ids?.length > 0) {
    body.contactId = JSON.parse(body.ids)[0];
    delete body.ids;
  } else if (body?.contactId) {
    body.contactId = JSON.parse(body.contactId);
  }

  if (request.method == 'PUT') {
    return patchSingle(baseURL + '/contact/add', params.id, body);
  } else if (request.method == 'DELETE') {
    return patchSingle(baseURL + '/contact/remove', params.id, body);
  } else {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }
}
